import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { TextInput } from "../Shared/Forms";
import { Spinner } from "../Shared";

import { idTypeActions } from "./actions/idtypes.actions";
import { routeConstants } from "../../_constants";

export class IdTypeForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getIdType();
  }

  componentWillUnmount() {
    this.props.resetIdType();
  }

  getIdType = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getIdType(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.idTypeForm.reset();
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      data = {
        id: match.params.id,
        ...data
      };
    }
    this.props.addIdType(data);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const idType = viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.IDTYPES.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Identification Type
                <small>{idType && hasParams ? `: ${idType.code}` : null}</small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="idTypeForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                <TextInput
                  name="code"
                  value={idType && hasParams ? idType.code : null}
                  required
                  disabled={submitting || hasParams}
                  title="Id type code"
                />
                <TextInput
                  name="description"
                  value={idType && hasParams ? idType.description : null}
                  required
                  disabled={submitting}
                  title="Id type description"
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { submitting, submitted, request, response, error } = state.addIdType;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewIdType;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addIdType: bindActionCreators(idTypeActions.addIdType, dispatch),
    resetIdType: bindActionCreators(idTypeActions.resetIdType, dispatch),
    getIdType: bindActionCreators(idTypeActions.getIdType, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdTypeForm);
